(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('PaymentImportSlipsFormController', PaymentImportSlipsFormController)

    /** @ngInject */
    function PaymentImportSlipsFormController($state, HelperService, PaymentSlipRemittanceService, PaymentSlipService, sweetAlert) {
        let vm = this;

        vm.flowFileAdded = $file => {
            let blacklist = ['txt'];
            let extension = $file.getExtension();

            if (!blacklist.includes(extension)) {
                HelperService.setErrorMessageForm('.payment-file', 'Por favor envie um arquivo no formato válido.', true);
                return false;
            }

            vm.paymentRemittance = {
                Description: vm.paymentRemittance.Description
            };

            vm.paymentSlips = [];
            vm.paymentSlipsCount = 0;
            vm.hasLoadedSlips = false;

            HelperService.startLoading('.loading-holder');
            HelperService.removeErrorMessageForm('.payment-file');
        }

        vm.flowFileSubmitted = $flow => {
            vm.hasLoadedSlips = false;

            $flow.upload();
        }

        vm.flowFileFinishedMain = ($file, $message) => {
            var message = angular.fromJson($message);

            vm.flowScopeMain.flow.files = [];

            saveRemittance(message.FileSaveName);
        }

        vm.flowFileError = (file, message, flow) => {
            HelperService.stopLoading('.loading-holder');

            var message = angular.fromJson(message);

            if (message && message.ModelState) {
                if (message.ModelState.file && message.ModelState.file[0] == 'size') {
                    NotifyService.error('O tamanho da imagem ultrapassa o limite de 2mb');
                } else {
                    NotifyService.error('Ocorreu um erro ao enviar a imagem, tente novamente');
                }

                if (vm.flowScopeMain.flow.files.length)
                    vm.flowScopeMain.flow.files[0].cancel();

                vm.paymentSlips = [];
                vm.paymentRemittance = {};
                vm.hasLoadedSlips = false;
            }
        }

        vm.importPaymentRemittanceSlips = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Essa ação não poderá ser desfeita',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.loading-holder');

                    PaymentSlipService
                        .importSlips(vm.paymentRemittance.Id)
                        .then(() => {
                            HelperService.stopLoading('.loading-holder');

                            $state.go('app.franchiser-payment-remittance-slips', {
                                paymentRemittanceId: vm.paymentRemittance.Id
                            });

                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.loading-holder');
                        })
                }
            })
        }

        vm.hasNewSlips = () => {
            let hasNewSlips = false;

            if (!vm.hasLoadedSlips)
                return hasNewSlips;

            for (let index = 0; index < vm.paymentSlips.length; index++) {
                if (!vm.paymentSlips[index].Duplicated) {
                    hasNewSlips = true;
                    break;
                }
            }

            return hasNewSlips;
        }

        init();

        function saveRemittance(remittanceFileName) {
            if (!vm.paymentRemittance.Description) {
                HelperService.setErrorMessageForm('.payment-description');
                return;
            }

            let paymentRemittanceData = {
                FileName: remittanceFileName,
                Description: vm.paymentRemittance.Description
            }

            PaymentSlipRemittanceService
                .save(paymentRemittanceData)
                .then(success => {
                    vm.paymentRemittance = success;

                    getPaymentSlips(vm.paymentRemittance.Id);
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');

                    vm.flowScopeMain.flow.files = [];
                })
        }

        function getPaymentSlips(paymentRemittanceId) {
            PaymentSlipService
                .getNotImported(paymentRemittanceId)
                .then(success => {
                    vm.paymentSlips = success;
                    vm.paymentSlipsCount = vm.paymentSlips.length;
                    vm.hasLoadedSlips = true;

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');

                    vm.flowScopeMain.flow.files = [];
                })
        }

        function init() {
            vm.paymentRemittance = {};
            vm.hasLoadedSlips = false;

            vm.flowOptionsMain = {
                query: () => {
                    return {
                        Path: 'payment-slips'
                    }
                }
            }

            angular.extend(vm.flowOptionsMain, HelperService.getFlowOptionsDefaultsPaymentSlip());
        }
    }
}());